
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-resources",
      function () {
        return require("private-next-pages/user-resources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-resources"])
      });
    }
  